<template>
  <div class="tourism-button-delete" @click="remove">
    観光ポイントを削除
  </div>
</template>

<script>
export default {
  methods: {
    remove: function () {
      if (window.confirm('本当に削除しますか？')) {
        this.$router.go(-1)
        this.$store.dispatch('tourism/deleteTourism')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tourism-button-delete {
  @include button-ol-danger;
}
</style>
